module.exports = __webpack_public_path__ + "static/media/project-image01.5ea27ecb.png";